import axiosClient from "./axiosClient";

export const loadAllNotesFromTask = async (projectId, taskId, uid) => {
  const response = await axiosClient.get(
    `/projects/${projectId}/tasks/${taskId}/notes`,
    {
      params: { uid },
    }
  );
  return response.data;
};

export const createNote = async (projectId, taskId, note) => {
  const response = await axiosClient.post(
    `/projects/${projectId}/tasks/${taskId}/notes`,
    note
  );
  return response.data;
};

export const updateNote = async (projectId, taskId, noteId, note) => {
  const response = await axiosClient.put(
    `/projects/${projectId}/tasks/${taskId}/notes/${noteId}`,
    note
  );
  return response.data;
};

export const deleteNoteById = async (projectId, taskId, noteId, uid) => {
  const response = await axiosClient.delete(
    `/projects/${projectId}/tasks/${taskId}/notes/${noteId}`,
    {
      data: { uid },
    }
  );
  return response.data;
};
